import React from 'react';
import { Input, Popover } from 'antd';
import PasswordRequirements from './PasswordRequirements';

interface PasswordInputWithRequirementsProps {
    value?: string;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    placeholder?: string;
    size?: 'large' | 'middle' | 'small';
    [key: string]: any;
}

const PasswordInputWithRequirements: React.FC<PasswordInputWithRequirementsProps> = ({
    value,
    onChange,
    ...props
}) => {
    return (
        <Popover
            content={<PasswordRequirements password={value} />}
            trigger="focus"
            placement="right"
            overlayStyle={{ width: 280 }}
        >
            <Input.Password
                value={value}
                onChange={onChange}
                autoComplete="new-password"
                {...props}
            />
        </Popover>
    );
};

export default PasswordInputWithRequirements;
